<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">个性短信</a></li>
            </ul>
        </div>    
        <div v-show="showBind" class="buttonupload  click left" @click="gotoBindMobile()" style="margin-left:120px; margin-top:50px;"><font color="red"><strong>您还未绑定手机号码，点击去绑定手机号码！</strong></font></div>
        <div class="formbody" v-show="showGeXing">  
            <ul class="seachform mt20" >    
                <li><label>群发导入</label>
                    <input name="" v-model="filename" type="text" class="scinput" />
                </li>    
                <li>
                    <label>&nbsp;</label>
                    <div style="float: left; padding-right: 10px;"> 
                        
                        <el-upload
                            class="upload-demo"
                            ref="upload"
                            :on-success="uploadSuccess"
                            :action=smsGeXingUploadUrl
                            :on-preview="handlePreview"
                            :file-list="fileList"
                            :auto-upload="false"
                            :show-file-list="false"
                            :headers="uploadHeaders"
                            :on-change="handleChange">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                        </el-upload>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;<a href="https://www.2office.cn/gxsample.txt" target="_blank">范本下载</a>
                </li>

            </ul>  
            <div class="lh33">注意:短信文件应该是txt文件，内容为号码+内容+拒收请回复R+【签名】</div>   
            <div class="lh33">注意: 根据工信管函[2023]794号文件要求，商业性短信退订格式统一调整为：拒收请回复R</div>   
            <div class="jian">&nbsp;</div> 
        </div> 
    
    
        <div class="tip">
            <div class="tiptop"><span>提示信息</span><a></a></div>        
            <div class="tipinfo">
                <span><img src="images/ticon.png" /></span>
                <div class="tipright">
                    <p>是否确认对信息的修改 ？</p>
                    <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
                </div>
            </div>
    
            <div class="tipbtn">
                <input name="" type="button"  class="sure" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" value="取消" />
            </div>    
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            uploadHeaders:{},
            smsGeXingUploadUrl:this.GLOBAL.serverSrc + '/sms/uploadsmsgexing.json',
            fileList:[],
            filename:'',
            showBind:false,
            showGeXing:true
        }
    },
    mounted(){
        //console.log(this.GLOBAL.token);
        //this.uploadHeaders.token = this.GLOBAL.token;
        this.initGeXing();
    },
    methods:{
        initGeXing(){
            let that = this;
            let data = {'mobile':'','content':''};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/initsmssendpage.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(JSON.stringify(res.data));
                if('0000000' == res.data.code)
                {
                    if('1' == res.data.yanzheng){
                        //console.log("显示绑定");
                        that.showBind = true;
                        that.showGeXing = false;
                    }
                    else{
                        //console.log("不显示绑定");
                        that.showBind = false;
                        that.showGeXing = true;
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            });
        },
        submitUpload(){
            this.uploadHeaders.token = this.GLOBAL.token;
            this.$refs.upload.submit();
        },
        uploadSuccess(response){
            if(response.code == '0000000'){
                alert("个性短信已经提交成功！审核通过后即会发送！");
                location.href = "/smscheck";
            }
            else if("0000006" == response.code){
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else{
                alert(response.msg);
                //console.log(JSON.stringify(response.data))
            }
        },
        handlePreview(file) {
            //console.log(file.name);
        },
        handleChange(file, fileList) {
            this.filename = file.name;
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
        },
        gotoBindMobile(){
            location.href = "/bindmobile"
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smsgexing.vue